let _viewer = null;

/**
 *
 * @param {object} options
 * @returns {Promise<import("@photo-sphere-viewer/core").Viewer>}
 */
export async function initPhotoSphereViewer(options) {
  if (_viewer) return _viewer;

  // This triggers loading of both chunks: three + photo-sphere-viewer
  const { Viewer } = await import("@photo-sphere-viewer/core");

  if (options.adapter === "EquirectangularTilesAdapter") {
    const { EquirectangularTilesAdapter } =
      await import("@photo-sphere-viewer/equirectangular-tiles-adapter");
    options.adapter = EquirectangularTilesAdapter;
  }

  _viewer = new Viewer({
    ...options,
  });

  return _viewer;
}

/**
 * Destroy the current PhotoSphereViewer instance
 */
export function destroyPhotoSphereViewer() {
  _viewer = null;
}
